// ------------------------------------------------------------------------------
// name: workshop
// author: mudas
// created: 2025/7/11
// ------------------------------------------------------------------------------

import qs from 'qs';
import { openURL } from 'common/utils';
import { FastApiAxiosInstance } from 'common/service/axiosInstances';
import {
  ActivityDateRange,
  ActivitySession,
  BaseWorkshopDetail,
  IPaginationParams,
  PaginationResult,
  ReviewRejectReason,
  WorkshopManageDetail,
  WorkshopManageListItem,
  WorkshopManageListParams,
  WorkshopNumOverview,
  WorkshopOrderListItem,
  WorkshopOrderListParams,
  WorkshopRecommendListItem,
  WorkshopRecommendParams,
  WorkshopReviewDetail,
  WorkshopReviewListItem,
  WorkshopReviewListParams,
  WorkshopReviewParams,
  WorkshopSeckillListItem,
  WorkshopSeckillListParams,
  WorkshopSeckillParams,
  WorkshopTakeDownParams,
} from 'common/types';

// --------------------------------------------------------------------------
//
// 列表和详情
//
// --------------------------------------------------------------------------

export const getWorkshopReviewList = (params: IPaginationParams<WorkshopReviewListParams>) => {
  return FastApiAxiosInstance.get<PaginationResult<WorkshopReviewListItem>>('/api/v1/backend/workshop/reviewList', {
    params,
  });
};

export const getWorkshopReviewDetail = (params: any) => {
  return FastApiAxiosInstance.get<WorkshopReviewDetail>('/api/v1/backend/workshop/reviewDetail', { params });
};

export const getWorkshopManageList = (params: IPaginationParams<WorkshopManageListParams>) => {
  return FastApiAxiosInstance.get<PaginationResult<WorkshopManageListItem>>('/api/v1/backend/workshop/list', {
    params,
  });
};

export const getWorkshopManageDetail = (params: any) => {
  return FastApiAxiosInstance.get<WorkshopManageDetail>('/api/v1/backend/workshop/detail', { params });
};

export const getWorkshopRecommendList = (params: IPaginationParams<WorkshopManageListParams>) => {
  return FastApiAxiosInstance.get<PaginationResult<WorkshopRecommendListItem>>(
    '/api/v1/backend/workshop/featuredList',
    {
      params,
    },
  );
};

// 秒杀工坊列表数据
export const getWorkshopSeckillList = (params: IPaginationParams<WorkshopSeckillListParams>) => {
  return FastApiAxiosInstance.get<PaginationResult<WorkshopSeckillListItem> & { activityId: number }>(
    '/api/v1/backend/workshop/seckillList',
    {
      params,
    },
  );
};

// 工坊订单列表数据
export const getWorkshopOrderList = (params: IPaginationParams<WorkshopOrderListParams>) => {
  return FastApiAxiosInstance.get<PaginationResult<WorkshopOrderListItem>>('/api/v1/backend/workshop/order/list', {
    params,
  });
};
export const exportWorkshopOrderList = (params: WorkshopOrderListParams) => {
  openURL(`/fastApi/api/v1/backend/workshop/order/export?${qs.stringify(params, { arrayFormat: 'comma' })}`);
};

export const workshopFuzzySearch = (params: { query: string }) => {
  return FastApiAxiosInstance.get<BaseWorkshopDetail[]>('/api/v1/backend/workshop/fuzzy', { params });
};

export const workshopActivityDateRange = (params: { activityId: number }) => {
  return FastApiAxiosInstance.get<ActivityDateRange>('/api/v1/backend/workshop/activityDateRange', {
    params,
  });
};

// 秒杀场次
export const workshopActivitySeckillSessions = () => {
  return FastApiAxiosInstance.get<ActivitySession[]>('/api/v1/backend/workshop/seckillSession');
};

// --------------------------------------------------------------------------
//
// 统计和其它操作
//
// --------------------------------------------------------------------------

export const getWorkshopNumOverview = async () => {
  return FastApiAxiosInstance.get<WorkshopNumOverview>('/api/v1/backend/workshop/numOverview');
};

export const workshopReview = (params: WorkshopReviewParams) => {
  return FastApiAxiosInstance.post('/api/v1/backend/workshop/review', params);
};

// 设置置顶权重
export const setPriority = (params: { workshopId: number; priority: number }) => {
  return FastApiAxiosInstance.post('/api/v1/backend/workshop/setPriority', params);
};

// 下架
export const workshopOff = (params: WorkshopTakeDownParams) => {
  return FastApiAxiosInstance.post('/api/v1/backend/workshop/delist', params);
};

// 拒绝通过审核的原因选项列表 /api/v1/backend/workshop/reviewRejectReasons
export const getReviewRejectReasons = async () => {
  return FastApiAxiosInstance.get<ReviewRejectReason[]>('/api/v1/backend/workshop/reviewRejectReasons');
};

// 工坊推荐
export const workshopRecommend = (params: WorkshopRecommendParams) => {
  return FastApiAxiosInstance.post('/api/v1/backend/workshop/feature', params);
};

// 取消工坊推荐
export const cancelWorkshopRecommend = (params: { workshopFeatureId: number }) => {
  return FastApiAxiosInstance.post('/api/v1/backend/workshop/cancelFeature', params);
};

// 工坊秒杀
export const workshopSeckill = (params: WorkshopSeckillParams) => {
  return FastApiAxiosInstance.post('/api/v1/backend/workshop/seckillAdd', params);
};

// 取消工坊秒杀
export const cancelWorkshopSeckill = (params: { workshopSeckillId: number }) => {
  return FastApiAxiosInstance.post('/api/v1/backend/workshop/cancelSeckill', params);
};
